import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const Canhbaohethantable = React.memo(function Canhbaohethantable(props) {
  const classes = useStyles();
  const { phuhieu, hangpkd } = props;
  const hethangpkd = () => {
    return (
      <div>
        <a className={classes.tieudegpkd}>
          Ngày cấp GPKD: {hangpkd[0].ngaycapgpdkkd}
        </a>
        <a className={classes.tieudegpkdred}>
          Ngày hết hạn GPKD: {hangpkd[0].ngayhethangpkdvt}
        </a>
      </div>
    );
  };
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th_dn}>Số đăng ký</th>
          <th className={classes.tablebc_th_dn}>Số phù hiệu</th>
          <th className={classes.tablebc_th_dn}>Ngày cấp</th>
          <th className={classes.tablebc_th_dn}>Ngày hết hạn</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {phuhieu.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["sodangky"]}</td>
              <td className={classes.tablesotan_td}>{row["sophuhieu"]}</td>
              <td className={classes.tablesotan_td}>{row["ngaycap"]}</td>
              <td className={classes.tablesotan_td}>{row["ngayhethan"]}</td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var hethan = hangpkd.length > 0 ? hethangpkd() : null;
  var tHead = phuhieu.length > 0 ? renderTableHead() : null;
  var tBody = phuhieu.length > 0 ? renderTableBody() : null;
  return (
    <div className={classes.table} style={{ height: "300px" }}>
      {hethan}
      {phuhieu.length > 0 ? (
        <a className={classes.tieudephuongtien}>
          DANH SÁCH PHƯƠNG TIỆN HẾT HẠN PHÙ HIỆU
        </a>
      ) : null}
      <table
        className={classes.tablebc}
        style={{ marginTop: 8, width: "98%", marginLeft: 10 }}
      >
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Canhbaohethantable.propTypes = {
  phuhieu: PropTypes.array,
  hangpkd: PropTypes.array,
};
export default Canhbaohethantable;
